import React from 'react';
import { Button } from 'glic-ui-components';
import ParentComponent from '../index';
import './index.scss';
import metaLogo from "../../../../assets/guardian.png";
import { Helmet } from "react-helmet";
import { setDomainUrl } from '../../../../utils/commonFunctions';

const Expired = () => {

  const handleRegisterBtn = () => {
    const host = window.location.host;
    window.location.href = `${setDomainUrl(host)}/registration/`;
  };

  const alertMainHeading = 'Your link has expired';
  const alertInfoText =
    'Don\'t worry, we\'ll get you back on track. You can register below to manage your benefits, claims and cards.';
  const registerBtn = (
    <Button
      onClick={handleRegisterBtn}
      type="primary"
      className="register_button"
    >
      Register now
    </Button>
  );

  const expiredPropsData = {
    alertMainHeading,
    alertInfoText,
    registerBtn,
  };

  return (
    <>
      {/* <h1>Link Expired page</h1> */}
      <Helmet>
        <title>Link has expired | Guardian</title>
        <link rel="icon" type="image/png" href={metaLogo} />
      </Helmet>
      <ParentComponent propData={expiredPropsData} />
    </>
  );
};

export default Expired;